import { queryOptions, useQuery, type UseQueryResult } from "@tanstack/react-query";
import { caseKeys } from "@/domains/cases/api/keys";
import type { CaseFile } from "@/domains/cases/api/types";
import { fetchCaseById, fetchCases } from "@/domains/cases/mocks/casesService";

export const casesListOptions = queryOptions({
  queryKey: caseKeys.lists(),
  queryFn: fetchCases,
});

export const caseDetailOptions = (id: string) =>
  queryOptions({
    queryKey: caseKeys.detail(id),
    queryFn: () => fetchCaseById(id),
  });

export function useCases(): UseQueryResult<ReadonlyArray<CaseFile>> {
  return useQuery(casesListOptions);
}

export function useCase(id: string): UseQueryResult<CaseFile | undefined> {
  return useQuery(caseDetailOptions(id));
}
